import React from 'react';

import { Button } from '@mui/material';

import useStyles from './styles';

interface Props {
    variant?: 'warning' | 'danger';
    title?: React.ReactNode;
    description?: React.ReactNode;
    action?: React.ReactNode;
    onClick?: () => void;
    className?: string;
}

const IssueCard: React.FC<Props> = ({ variant = 'warning', title, description, action, onClick, className }) => {
    const { classes, cx } = useStyles({ variant });
    return (
        <div className={cx(classes.root, className)}>
            {title || description ? (
                <div className={classes.text}>
                    {title ? <span className={classes.title}>{title}</span> : null}
                    {description ? <span className={classes.description}>{description}</span> : null}
                </div>
            ) : null}
            {action ? (
                <Button
                    variant="contained"
                    disableElevation
                    disableRipple
                    fullWidth
                    onClick={onClick}
                    className={classes.action}
                >
                    {action}
                </Button>
            ) : null}
        </div>
    );
};
export default IssueCard;
